import React, { useState } from 'react'
import { useNavigate } from 'react-router-dom'
import { Button } from '@wove/web-ui'
import { Plus } from 'lucide-react'
import { useCreateIntegration, CreateIntegrationRequest } from '@wove/api'
import AddIntegrationForm from './AddIntegrationForm'
import { toast } from 'sonner'

interface AddIntegrationProps {
  trigger?: React.ReactNode
}

export default function AddIntegration({ trigger }: AddIntegrationProps) {
  const [showForm, setShowForm] = useState(false)
  const navigate = useNavigate()
  const createMutation = useCreateIntegration()

  const handleCreate = async (
    data: CreateIntegrationRequest & { includeSettings?: boolean; cargoWiseSettings?: any },
  ) => {
    try {
      const integration = await createMutation.mutateAsync({
        integrationType: data.integrationType,
        integrationSource: data.integrationSource,
        metadata: data.metadata,
      })

      setShowForm(false)

      // Navigate to the new integration's detail page
      navigate(`/settings/integrations/${integration.id}`)
    } catch (error) {
      toast.error('Failed to create integration')
      // Error handling is managed by the mutation hook
    }
  }

  const defaultTrigger = (
    <Button onClick={() => setShowForm(true)} className="flex items-center gap-2">
      <Plus className="h-4 w-4" />
      Add Integration
    </Button>
  )

  return (
    <>
      {trigger ? <div onClick={() => setShowForm(true)}>{trigger}</div> : defaultTrigger}

      {showForm && (
        <AddIntegrationForm
          onSubmit={handleCreate}
          onCancel={() => setShowForm(false)}
          isSubmitting={createMutation.isPending}
        />
      )}
    </>
  )
}
